import { filterWithPaginationStates, useFilterWithPaginationV2 } from 'hooks';
import {
  type FilterWithPaginationStateShape,
  DEFAULT_PAGINATION,
  type DefaultPagination,
} from 'hooks/useFilterWithPagination';
import type { CreditInvoiceFilter } from 'lib/services';

const STATE_KEY = 'resellers/credits' as const;

export const DEFAULT_CREDITS_FILTER: CreditInvoiceFilter = {
  customers: undefined,
  resellers: undefined,
  search: undefined,
  sort: '-date',
};

export const DEFAULT_CREDITS_PAGINATION: DefaultPagination = DEFAULT_PAGINATION;

export type FilterWithPaginationShape = FilterWithPaginationStateShape<CreditInvoiceFilter>;

const states = filterWithPaginationStates({
  domainKey: STATE_KEY,
  filterDefaultValue: DEFAULT_CREDITS_FILTER,
  paginationDefaultValue: DEFAULT_CREDITS_PAGINATION,
});

export const useFilterWithPagination = (): FilterWithPaginationShape => useFilterWithPaginationV2(states);
